import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, DATE_WITH_HOUR_FORMAT, ICustomTable, LoadingPanelService, LocalService, Page } from 'lib-base';
import { SolicitudRevocacionService } from '../../../services/database/solicitud-revocacion.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ISolicitudRevocacion } from '../../../shared/interfaces/database/firma_electronica';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-revocaciones-finalizadas',
  standalone: true,
  imports: [CustomTableComponent],
  template: `
    <custom-table [config]="customTable" (emitterLazyLoad)="lazyloadRecords($event)">
    </custom-table>
  `
})
export class RevocacionesFinalizadasComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _t: TranslateService, private readonly _sr: SolicitudRevocacionService, private readonly _lps: LoadingPanelService,
    public ls: LocalService, private readonly _router: Router
  ) { }

  ngOnInit(): void {
    this.translate().then(() => this.configurarTabla());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      fechaActualización: this._t.get('common.fechaActualización'),
      fechaSolicitud: this._t.get('common.fechaSolicitud'),
      noSolicitud: this._t.get('common.noSolicitud'),
      abrir: this._t.get('common.abrir'),
      motivoRevocacion: this._t.get('common.motivoRevocacion'),
      justificacionRevocacion: this._t.get('msg.justificacionRevocacion'),
      funcionarioRespuesta: this._t.get('common.funcionarioRespuesta'),
      aprobada: this._t.get('common.aprobada'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      funcionarioObservacion: this._t.get('common.funcionarioObservacion'),
      cuidadanoNombre: this._t.get('cuidadanoNombre'),
    }));
  }

  configurarTabla(): void {
    this.customTable = {
      header: {},
      columns: [
        {
          field: 'id',
          header: this.trans.noSolicitud,
          class: 'font-13',
          width: '2rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombreCompleto',
          header: this.trans.cuidadanoNombre,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'motivoRevocacion',
          header: this.trans.motivoRevocacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'justificacionRevocacion',
          header: this.trans.justificacionRevocacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'funcionarioRespuestaNombre',
          header: this.trans.funcionarioRespuesta,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'aprobada',
          header: this.trans.aprobada,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'funcionarioObservacion',
          header: this.trans.funcionarioObservacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          format: DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          format: DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        }
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  getRevocacionesFinalizadas(event?: TableLazyLoadEvent) {
    this._sr.getSolicitudesFinalizadas(event).subscribe({
      next: (data: Page<ISolicitudRevocacion>) => {
        this._lps.hide();
        this.customTableComponent.data = data.content;
        this.customTableComponent.totalRecords = data.totalElements;
      }
    });
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    this.getRevocacionesFinalizadas(event);
  }

  onClick(data: ISolicitudRevocacion) {
    //this._router.navigate(['/configuracion/pqrsd-actividad/', this.solicitudId, data.id]);
  }

}
